import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  getCurrentLanguage() {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.paramMap.get('language');
  }

  getDefaultLanguage() {
    return navigator.language?.split('-')[0] || (navigator as any).userLanguage?.split('-')[0];
  }
}
